import { defineComponent as T, mergeModels as u, useModel as y, createElementBlock as a, openBlock as s, createElementVNode as o, renderSlot as I, Fragment as m, renderList as b, withDirectives as g, unref as l, vModelRadio as k, createCommentVNode as c, createTextVNode as S, toDisplayString as h, createVNode as p } from "vue";
import { ScalarIconPencilSimple as C, ScalarIconPlus as E } from "@scalar/icons";
import { getCustomTabsInputId as f } from "./helpers.js";
const V = { class: "custom-tabs-container" }, $ = ["id", "name", "value"], M = {
  class: "custom-tabs-navbar",
  contenteditable: "false"
}, N = { class: "custom-tabs-nav" }, B = ["for"], F = /* @__PURE__ */ T({
  __name: "ScalarTabs",
  props: /* @__PURE__ */ u({
    children: {},
    isEditable: { type: Boolean, default: !1 },
    uid: {}
  }, {
    currentTabIndex: { default: 0 },
    currentTabIndexModifiers: {}
  }),
  emits: /* @__PURE__ */ u(["editTab", "addTab"], ["update:currentTabIndex"]),
  setup(v) {
    const d = y(v, "currentTabIndex");
    return (e, t) => (s(), a("div", V, [
      (s(!0), a(m, null, b(e.children, (n, r) => g((s(), a("input", {
        id: l(f)(n.uid),
        key: n.uid,
        "onUpdate:modelValue": t[0] || (t[0] = (i) => d.value = i),
        class: "custom-tabs-input sr-only",
        name: `custom-tabs-${e.uid}`,
        type: "radio",
        value: r
      }, null, 8, $)), [
        [k, d.value]
      ])), 128)),
      o("div", M, [
        o("nav", N, [
          (s(!0), a(m, null, b(e.children, (n, r) => (s(), a("label", {
            key: n.uid,
            class: "custom-tabs-tab",
            for: l(f)(n.uid)
          }, [
            S(h(n.name) + " ", 1),
            e.isEditable && r === d.value ? (s(), a("button", {
              key: 0,
              class: "custom-tabs-edit-tab",
              type: "button",
              onClick: t[1] || (t[1] = (i) => e.$emit("editTab", i.target))
            }, [
              p(l(C))
            ])) : c("", !0)
          ], 8, B))), 128)),
          e.isEditable && e.children.length <= 9 ? (s(), a("button", {
            key: 0,
            class: "custom-tabs-edit-tab",
            style: { "margin-left": "-8px" },
            type: "button",
            onClick: t[2] || (t[2] = (n) => e.$emit("addTab"))
          }, [
            p(l(E))
          ])) : c("", !0)
        ])
      ]),
      I(e.$slots, "default", {}, () => [
        t[3] || (t[3] = o("div", { class: "custom-tabs-content" }, [
          o("ssg-children")
        ], -1))
      ], !0)
    ]));
  }
});
export {
  F as default
};
